import BaseModelAPI from '../BaseModelAPI';

export default class PartDetail extends BaseModelAPI {
	static entity = 'partdetail';
	static entityName = 'partdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.supplierCodeId = '';
			this.supplierCode = {};
			this.partId = '';
			this.part = {};
			this.supplierName = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}